import { z } from 'zod';

export const providerKeySchema = z.enum([
  'groq',
  'kilocode',
  'openai',
  'anthropic',
  'gemini',
  'openrouter',
]);

export const providerTypeSchema = z.enum([
  'research_lab',
  'third_party',
  'self_hosted',
]);

export const llmProviderSchema = z.object({
  id: z.string(),
  providerKey: providerKeySchema,
  displayName: z.string(),
  providerType: providerTypeSchema,
  baseUrl: z.string(),
  hasApiKey: z.boolean(),
  model: z.string().nullable(),
  availableModels: z.array(z.string()),
  isPrimary: z.boolean(),
  isSelectable: z.boolean(),
  lastTestedAt: z.string().nullable(),
  testStatus: z.enum(['success', 'error']).nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const saveProviderSchema = z.object({
  providerKey: providerKeySchema,
  apiKey: z.string().optional(),
  baseUrl: z.string().optional(),
  model: z.string().optional(),
  availableModels: z.array(z.string()).optional(),
  isPrimary: z.boolean().optional(),
});

export const listModelsSchema = z.object({
  providerKey: providerKeySchema,
  apiKey: z.string().optional(),
  baseUrl: z.string().optional(),
});

export const listModelsResponseSchema = z.object({
  providerKey: providerKeySchema,
  models: z.array(z.string()),
  count: z.number(),
  fetchedAt: z.string(),
});

export const testConnectionSchema = z.object({
  providerKey: providerKeySchema,
  apiKey: z.string().optional(),
  baseUrl: z.string().optional(),
  model: z.string().optional(),
  requestId: z.string().optional(),
});

export const testConnectionResponseSchema = z.object({
  ok: z.boolean(),
  message: z.string(),
  latencyMs: z.number(),
  responseText: z.string(),
  requestId: z.string(),
});

export const listProvidersResponseSchema = z.object({
  providers: z.array(llmProviderSchema),
  enabledProviderKeys: z.array(providerKeySchema),
});

export const listProvidersWorkerResponseSchema = listProvidersResponseSchema;

export const setPrimaryProviderRequestSchema = z.object({
  providerId: z.string().trim().min(1),
});

export const setPrimaryProviderResponseSchema = z.object({
  providers: z.array(llmProviderSchema),
});

export const deleteProviderRequestSchema = z.object({
  providerId: z.string().trim().min(1),
});

export const deleteProviderResponseSchema = z.object({
  deleted: z.boolean(),
});

export const resolveExecutionProviderRequestSchema = z.object({
  providerKey: providerKeySchema.optional(),
});

export const resolveExecutionProviderResponseSchema = z.object({
  providerKey: providerKeySchema,
  apiKey: z.string(),
  baseUrl: z.string(),
  model: z.string().optional(),
});

export const llmProvidersHealthResponseSchema = z.object({
  status: z.enum(['healthy', 'degraded']),
  providerCount: z.number(),
  encryptionConfigured: z.boolean(),
  timestamp: z.string(),
});
